import { gql } from '@apollo/client';

export const CREATE_CHECKLIST_QUESTION_MUTATION = gql`
  mutation createChecklistQuestion(
    $text: String!
    $guidance: String
    $description: String
    $nonComplianceIds: [Int!]
    $clientSpecificConfigurations: [ClientSpecificChecklistQuestionConfigurationInputObject!]!
    $negativeResultAlert: ChecklistQuestionNegativeResultAlertEnum!
    $negativeResultSeverityId: Int
    $checklistQuestionIdAlias: String!
    $isWildCardQuestion: Boolean
    $skipImportForDesktop: Boolean
    $skipImportForWeb: Boolean
  ) {
    createChecklistQuestion(
      text: $text
      guidance: $guidance
      description: $description
      nonComplianceIds: $nonComplianceIds
      clientSpecificConfigurations: $clientSpecificConfigurations
      negativeResultAlert: $negativeResultAlert
      negativeResultSeverityId: $negativeResultSeverityId
      checklistQuestionIdAlias: $checklistQuestionIdAlias
      isWildCardQuestion: $isWildCardQuestion
      skipImportForDesktop: $skipImportForDesktop
      skipImportForWeb: $skipImportForWeb
    ) {
      checklistQuestion {
        id
        currentVersion {
          id
          createdById
          status
          updatedById
          version
          text
          guidance
          description
          negativeResultAlert
          checklistQuestionIdAlias
          negativeResultSeverityId
          nonCompliances {
            id
            description
          }
          clientSpecificConfigurations {
            id
            companyId
            text
            guidance
            description
            logicType
            serviceIds
          }
          isWildCardQuestion
          skipImportForDesktop
          skipImportForWeb
        }
      }
    }
  }
`;

export const ADD_CHECKLIST_QUESTION_VERSION_MUTATION = gql`
  mutation addVersionToChecklistQuestion(
    $checklistQuestionId: Int!
    $publish: Boolean
    $text: String!
    $guidance: String
    $description: String
    $nonComplianceIds: [Int!]
    $clientSpecificConfigurations: [ClientSpecificChecklistQuestionConfigurationInputObject!]!
    $negativeResultAlert: ChecklistQuestionNegativeResultAlertEnum!
    $negativeResultSeverityId: Int
    $checklistQuestionIdAlias: String!
    $isWildCardQuestion: Boolean
    $skipImportForDesktop: Boolean
    $skipImportForWeb: Boolean
  ) {
    addVersionToChecklistQuestion(
      checklistQuestionId: $checklistQuestionId
      publish: $publish
      text: $text
      guidance: $guidance
      description: $description
      nonComplianceIds: $nonComplianceIds
      clientSpecificConfigurations: $clientSpecificConfigurations
      negativeResultAlert: $negativeResultAlert
      negativeResultSeverityId: $negativeResultSeverityId
      checklistQuestionIdAlias: $checklistQuestionIdAlias
      isWildCardQuestion: $isWildCardQuestion
      skipImportForDesktop: $skipImportForDesktop
      skipImportForWeb: $skipImportForWeb
    ) {
      checklistQuestionVersion {
        id
        createdById
        status
        updatedById
        version
        text
        guidance
        description
        checklistQuestionIdAlias
        negativeResultAlert
        negativeResultSeverityId
        nonCompliances {
          id
          description
        }
        clientSpecificConfigurations {
          id
          companyId
          text
          guidance
          description
          logicType
          serviceIds
        }
        isWildCardQuestion
        skipImportForDesktop
        skipImportForWeb
      }
    }
  }
`;

export const EDIT_CHECKLIST_QUESTION_VERSION_MUTATION = gql`
  mutation editDraftChecklistQuestionVersion(
    $checklistQuestionId: Int!
    $publish: Boolean
    $text: String!
    $guidance: String
    $description: String
    $nonComplianceIds: [Int!]
    $clientSpecificConfigurations: [ClientSpecificChecklistQuestionConfigurationInputObject!]!
    $negativeResultAlert: ChecklistQuestionNegativeResultAlertEnum!
    $negativeResultSeverityId: Int
    $checklistQuestionIdAlias: String!
    $isWildCardQuestion: Boolean
    $skipImportForDesktop: Boolean
    $skipImportForWeb: Boolean
  ) {
    editDraftChecklistQuestionVersion(
      checklistQuestionId: $checklistQuestionId
      publish: $publish
      text: $text
      guidance: $guidance
      description: $description
      nonComplianceIds: $nonComplianceIds
      clientSpecificConfigurations: $clientSpecificConfigurations
      negativeResultAlert: $negativeResultAlert
      negativeResultSeverityId: $negativeResultSeverityId
      checklistQuestionIdAlias: $checklistQuestionIdAlias
      isWildCardQuestion: $isWildCardQuestion
      skipImportForDesktop: $skipImportForDesktop
      skipImportForWeb: $skipImportForWeb
    ) {
      checklistQuestionVersion {
        checklistQuestionId
        checklistQuestionIdAlias
        createdById
        id
        status
        updatedById
        version
        text
        guidance
        description
        negativeResultAlert
        negativeResultSeverityId
        nonCompliances {
          id
          description
        }
        clientSpecificConfigurations {
          id
          companyId
          text
          guidance
          description
          logicType
          serviceIds
        }
        isWildCardQuestion
        skipImportForDesktop
        skipImportForWeb
      }
    }
  }
`;
